import { useState } from "react";

const RateInput = props => {

    const [value, setValue] = useState(props.defaultValue || 9);

    return (
        <div className="rate-input-wrapper margin-bottom-large">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => (
                <button
                    key={item}
                    type="button"
                    className={`rateInputItem ${value === item ? "active" : ""}`}
                    onClick={() => {
                        setValue(item);
                        props.onChanage(item);
                    }}
                >
                    {item}
                </button>
            ))}
        </div>
    )
}

export default RateInput;